import { useAuthContext, usePermissions } from '/src/hooks';
import { UpsellWall } from '/src/components/UpsellWall';
import { FEATURES } from '/src/features/_global/constants';

import FeaturedImagePNG from '@crazyegginc/hatch/dist/images/illustration-upsell-snapshots.png';
import FeaturedImageWebP from '@crazyegginc/hatch/dist/images/illustration-upsell-snapshots.webp';
import LeftPeoplePhotoPNG from '@crazyegginc/hatch/dist/images/people-veronika-vebere.png';
import RightPeoplePhotoPNG from '@crazyegginc/hatch/dist/images/people-arkady-pildes.png';
import LeftLogoPNG from '@crazyegginc/hatch/dist/images/logo-sendible.png';
import LeftLogoWebP from '@crazyegginc/hatch/dist/images/logo-sendible.webp';
import { ReactComponent as RightLogoIcon } from '@crazyegginc/hatch/dist/images/logo-radio-free.svg';

const TEXT_LIST = [
  {
    text: 'Identify what captures attention and what visitors are overlooking',
  },
  {
    text: 'Uncover frustrations and what drives users away to fix it fast',
  },
  {
    text: 'Monitor user behavior pre- and post-launch or risk flying blind',
  },
];

const TextContent = ({ canManageBilling, ownerEmail, isStripeUser }) => {
  return (
    <>
      <UpsellWall.Title
        titleText={
          canManageBilling ? 'Back your redesign with user insights' : 'Request an upgrade to the Starter plan'
        }
        subtitleText={!canManageBilling ? "Find out what's working and what's not on your site." : null}
      />
      {canManageBilling ? (
        <UpsellWall.List list={TEXT_LIST} />
      ) : (
        <>
          <p className="mb-6 text-black-pearl-500 text-sm">
            Contact your Account Admin at <strong>{ownerEmail}</strong> to upgrade and access Snapshots.
          </p>
        </>
      )}
      <UpsellWall.CTA
        metricType="snapshots_upsell_paywall"
        canManageBilling={canManageBilling}
        ownerEmail={ownerEmail}
        isStripeUser={isStripeUser}
      />
    </>
  );
};

const LeftContent = () => {
  return (
    <>
      <UpsellWall.TestimonialText textClassNames="mb-10">
        For me, the win was clear immediately over Hotjar just because of the kinds of insights we are getting. Crazy
        Egg&apos;s confetti report is the report that every marketer dreams of.
      </UpsellWall.TestimonialText>
      <UpsellWall.TestimonialPerson
        name="Veronika Vebere"
        title="Inbound Marketing Manager"
        imagePNG={LeftPeoplePhotoPNG}
        imageWidth="40"
        imageHeight="40"
        logoWebP={LeftLogoWebP}
        logoPNG={LeftLogoPNG}
        logoWidth="137"
        logoHeight="40"
        logoAlt="sendible"
      />
    </>
  );
};

const RightContent = () => {
  return (
    <>
      <UpsellWall.TestimonialText textClassNames="mb-10">
        [Crazy Egg] became an essential element of our qualitative performance evaluation. The teams that pay attention
        to the maps get their pages improved dramatically.
      </UpsellWall.TestimonialText>
      <UpsellWall.TestimonialPerson
        name="Arkady Pildes"
        title="Radio Free Europe"
        imagePNG={RightPeoplePhotoPNG}
        imageWidth="40"
        imageHeight="40"
        logoSVG={RightLogoIcon}
        logoWidth="137"
        logoHeight="40"
        logoAlt="radio free europe"
      />
    </>
  );
};

export function SnapshotsUpsellPaywall() {
  const { currentAccount } = useAuthContext();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isStripeUser = Boolean(currentAccount?.useStripe);

  return (
    <UpsellWall>
      <UpsellWall.TopPanel
        textContent={
          <TextContent
            canManageBilling={canManageBilling}
            ownerEmail={currentAccount.ownerEmail}
            isStripeUser={isStripeUser}
          />
        }
        imagePNG={FeaturedImagePNG}
        imageWebP={FeaturedImageWebP}
        imageWidth="522"
        imageHeight="256"
        imageAlt="snapshots feature"
      />
      <UpsellWall.BottomPanel isSeparate={true} leftContent={<LeftContent />} rightContent={<RightContent />} />
    </UpsellWall>
  );
}
